import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form'

import auth from './auth'
import register from './register'

const rootReducer = combineReducers({
  auth,
  register,
  form: formReducer
});

export default rootReducer;
